import { Alert, CollapseProps, Typography } from 'antd'

const { Title } = Typography

export const helpItemsList: CollapseProps['items'] = [
    {
        key: '1',
        label: <b>Обзор раздела</b>,
        children: (
            <>
                <p>
                    Раздел «Клиенты» — справочник клиентов компании. Данные клиента используются при
                    создании расчётов и отгрузок: выбор клиента в расчёте, адреса и контакты для
                    доставки.
                </p>
                <Alert
                    showIcon
                    style={{ marginTop: 8 }}
                    message='Клиента можно создать и в разделе «Расчёты» при оформлении нового расчёта. Такой клиент сохраняется в статусе «Черновик» до проверки логистами. Подробнее — в разделе «Расчёты» → «Помощь».'
                    type='info'
                />
            </>
        ),
    },
    {
        key: '2',
        label: <b>Кто что видит</b>,
        children: (
            <>
                <p>
                    Список клиентов зависит от вашей роли и того, указаны ли вы куратором у
                    клиента.
                </p>
                <ul>
                    <li>
                        <b>Менеджер</b> — клиенты, где куратором указан он сам или его помощники.
                    </li>
                    <li>
                        <b>Помощник менеджера</b> — клиенты, где куратором указан он сам или его
                        менеджеры.
                    </li>
                    <li>
                        <b>Логист и Супер Админ</b> — все клиенты без ограничений.
                    </li>
                </ul>
                <p>
                    Именно «свои» клиенты доступны менеджеру и помощнику при выборе клиента в
                    новом расчёте.
                </p>
            </>
        ),
    },
    {
        key: '3',
        label: <b>Поиск и таблица</b>,
        children: (
            <>
                <Title level={3}>Поиск</Title>
                <p>
                    Поле «Поиск по имени» фильтрует таблицу по названию клиента. Очистка поля
                    возвращает полный список.
                </p>
                <Title level={3}>Колонки</Title>
                <ul>
                    <li>
                        <b>Название</b> — имя клиента.
                    </li>
                    <li>
                        <b>Юр. адрес</b> — юридический адрес.
                    </li>
                    <li>
                        <b>Комментарий</b> — произвольный комментарий к клиенту.
                    </li>
                    <li>
                        <b>Кураторы</b> — менеджеры и помощники, закреплённые за клиентом, с
                        указанием процента (например, «ivanov (3%)»).
                    </li>
                    <li>
                        <b>Контакты</b> — адрес, имя и телефон получателя, часы работы, комментарий.
                        Звёздочка (★) отмечает основной контакт. У клиента может быть несколько
                        контактов — каждый отображается отдельной строкой в ячейке.
                    </li>
                    <li>
                        <b>Статус</b> — «Черновик» или «Подтвержден».
                    </li>
                </ul>
            </>
        ),
    },
    {
        key: '4',
        label: <b>Статус подтверждения</b>,
        children: (
            <>
                <p>У каждого клиента есть статус подтверждения:</p>
                <ul>
                    <li>
                        <b>Черновик</b> — клиент создан или изменён менеджером, данные ещё не
                        проверены логистами.
                    </li>
                    <li>
                        <b>Подтвержден</b> — логист проверил адрес и данные клиента.
                    </li>
                </ul>
                <p>
                    Кнопка «Подтвердить» в колонке статуса доступна только логисту и только для
                    клиентов в статусе «Черновик».
                </p>
                <Alert
                    showIcon
                    style={{ marginTop: 8 }}
                    message='После подтверждения менеджеры и помощники не могут редактировать карточку клиента. Правки вносят логисты.'
                    type='warning'
                />
                <p>
                    Для запуска отгрузки по новому клиенту передайте данные логистам: они проверят
                    адрес и подтвердят клиента.
                </p>
            </>
        ),
    },
    {
        key: '5',
        label: <b>Действия</b>,
        children: (
            <>
                <ul>
                    <li>
                        <b>Добавить клиента</b> — переход на форму создания нового клиента.
                    </li>
                    <li>
                        <b>Редактировать</b> (иконка в строке) — переход на форму редактирования
                        выбранного клиента.
                    </li>
                </ul>
            </>
        ),
    },
]
